import { Controller } from '@hotwired/stimulus';

/**
 * Ramène son élément hôte dans le champ de vision au `connect()`, et lui donne
 * le focus quand il est focalisable.
 *
 * POURQUOI IL EXISTE. Le formulaire de situation répond à un refus par un
 * `turbo_stream` (`WorkProgressStatementsController#handle_failed_create`), pas
 * par une navigation : Turbo applique les `update` sur place et ne touche jamais
 * au scroll. L'architecte cliquait « Enregistrer la situation » en bas de page
 * et ne voyait STRICTEMENT rien bouger, le message étant à quelques milliers de
 * pixels au-dessus — le retour QA du 2026-08-04, mot pour mot : « il ne se passe
 * rien ». Aucun motif de scroll-vers-l'erreur serveur n'existait dans le dépôt.
 *
 * POURQUOI PAS `autofocus`. Ce contrôleur-là scrolle AUSSI, mais son nom et son
 * docblock promettent le focus d'un champ de saisie nommé (`data-autofocus-target
 * ="field"`), ce qui n'est pas ce qui se passe ici. Deux intentions sur un même
 * nom, c'est un commentaire qui devient faux.
 *
 * POURQUOI `connect()`. Le contrôleur n'est présent dans le DOM que lorsque la
 * zone porte réellement une erreur — les deux hôtes s'auto-effacent quand il n'y
 * en a pas — et il se reconnecte à chaque `turbo_stream.update` de son
 * conteneur. Pas de listener global, donc rien à retirer en `disconnect()`.
 *
 * `focus()` n'est tenté que sur un hôte explicitement focalisable : un `focus()`
 * sur un nœud qui ne l'est pas est un no-op silencieux, et l'appeler quand même
 * laisserait croire que l'annonce lecteur d'écran est acquise. `preventScroll`
 * protège le défilement doux qu'on vient de déclencher.
 *
 *   data-controller="scroll-into-view"
 *   tabindex="-1"   // optionnel : ajoute le focus au défilement
 */
export default class extends Controller {
  connect() {
    this.element.scrollIntoView({ behavior: 'smooth', block: 'center' });

    if (this.element.hasAttribute('tabindex')) {
      this.element.focus({ preventScroll: true });
    }
  }
}
